import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { argentineCities, argentineNames } from '../data/salesData';
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: ''
  });
  const generateRandomPurchase = () => {
    const name = argentineNames[Math.floor(Math.random() * argentineNames.length)];
    const city = argentineCities[Math.floor(Math.random() * argentineCities.length)];
    return {
      name,
      city
    };
  };
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(generateRandomPurchase());
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialDelay = setTimeout(showPopup, 30000);
    const interval = setInterval(showPopup, 30000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-221">
      {isVisible && <motion.div initial={{
      x: -400,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -400,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 25
    }} className="fixed bottom-6 left-6 z-50 max-w-sm" data-id="element-222">
          <div className="bg-white rounded-lg shadow-2xl p-4 border-l-4 border-primary relative" data-id="element-223">
            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-224">
              <XIcon className="w-4 h-4" data-id="element-225" />
            </button>

            <div className="flex items-start gap-3" data-id="element-226">
              <div className="text-2xl" data-id="element-227">🎉</div>
              <div className="flex-1" data-id="element-228">
                <p className="font-bold text-gray-900 text-sm mb-1" data-id="element-229">
                  {currentPurchase.name} de {currentPurchase.city}
                </p>
                <p className="text-xs text-gray-600" data-id="element-230">
                  acaba de comprar STRETCHING 360
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}